import * as React from "react";
import { Card, makeStyles } from "@material-ui/core";

import { Source } from "services/valuation/types";
import theme from "theme";

const useStyles = makeStyles({
  tooltipContainer: {
    border: `1px solid ${theme.custom.palette.gray.dark}`,
    padding: theme.spacing(2),
    "& *": {
      fontSize: "16px",
      color: theme.palette.primary.main,
      whiteSpace: "nowrap",
      margin: 0,
    },
    "& p": {
      padding: 0,
      textAlign: "start",
    },
    "& li": {
      padding: 0,
      textAlign: "start",
    },
  },
});

interface ChartData {
  name: string;
  value: number;
}

interface SourceBreakdownChartCustomTooltipProps {
  payload?: [ChartData];
  totalValue: number;
  sources: Source[];
}

const SourceBreakdownChartCustomTooltip: React.FC<SourceBreakdownChartCustomTooltipProps> = ({
  payload,
  totalValue,
  sources,
}) => {
  const classes = useStyles();

  let tooltipContent = null;

  if (payload && payload.length > 0) {
    const [entry] = payload;
    const percentage = Math.round((entry.value / totalValue) * 100);

    const earningDetails = sources
      .filter(
        source =>
          source.name === entry.name &&
          !!source.earning_details &&
          source.earning_details.length > 0,
      )
      .map(source =>
        source.earning_details
          .filter(
            detail => Math.round((detail.earnings / entry.value) * 100) !== 0,
          )
          .map(detail => ({
            name: detail.name,
            percentage: Math.round((detail.earnings / entry.value) * 100),
          })),
      )
      .flat();

    tooltipContent = {
      name: entry.name,
      percentage,
      earningDetails,
    };
  }

  return (
    <Card className={classes.tooltipContainer}>
      {tooltipContent && (
        <>
          <p>
            {tooltipContent.percentage}% {tooltipContent.name}
          </p>
          <ul>
            {tooltipContent.earningDetails.map(detail => (
              <li key={detail.name}>
                {detail.percentage}% {detail.name}
              </li>
            ))}
          </ul>
        </>
      )}
    </Card>
  );
};

export default SourceBreakdownChartCustomTooltip;
